<template>
  <form @submit.prevent="savePermisos" class="d-flex flex-column gap-2 w-100 fondo-terciario rounded-4 p-3 px-4 sombra-sm" style="max-height: 90vh;">
    <div class="d-flex flex-row justify-content-between gap-2">
      <p class="m-0 fs-5 w-100" style="max-width: 130px;"><strong>{{ $t('permisos') }}:</strong></p>
      <button @click="isEditingPermisos = true" v-if="!isEditingPermisos" class="btn p-0 d-flex flex-row align-items-center justify-content-center tooltip-container border-0">
        <svg width="20" height="20" viewBox="0 0 24 24" class="stroke-principal" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M21 21H12" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="tooltip-text">{{ $t('editar') }}</span>
      </button>
    </div>

    <div class="scroll">
      <div class="d-flex flex-column gap-3">
        <div v-for="group in groupedPermisos" :key="group.name">
          <!-- <h5 class="mt-3">{{ group.name }}</h5> <hr class="my-2"> -->
          <div class="m-0 fs-8 mb-1 d-flex gap-3 align-items-start">
            <p class="fs-6 m-0 text-end" style="flex: 1;">
              <span class="fw-bold">{{ group.name }}</span>
            </p>
            <div style="flex: 2;">
              <div v-for="subgroup in group.subcategories" :key="subgroup.IdPermiso">
                <div v-if="subgroup.permiso != 'General'" class="form-check d-flex gap-3 p-0">
                  <input
                    class="form-check-input sombra-sm m-0"
                    :class="{'form-check-input-gris': isSubcategoryChecked(subgroup).checkedEnRol}"
                    type="checkbox"
                    :checked="isSubcategoryChecked(subgroup).checked"
                    @change="toggleSubcategory(subgroup, $event.target.checked)"
                    :disabled="!isEditingPermisos || isSubcategoryChecked(subgroup).checkedEnRol"
                  />
                  <div class="d-flex gap-1" @click="expandedSubcategories[subgroup.IdPermiso] = !expandedSubcategories[subgroup.IdPermiso]" style="cursor: pointer;">
                    <p class="m-0 text-start" :class="{'texto-secundario': !isEditingPermisos || isSubcategoryChecked(subgroup).checkedEnRol}">{{ subgroup.permiso }}</p>
                    <p class="m-0 text-start" :class="{'texto-secundario': !isEditingPermisos || isSubcategoryChecked(subgroup).checkedEnRol}">({{ subgroup.children.filter( c => hasPermiso(c.IdPermiso, c.SubCategoria).enPermiso || hasPermiso(c.IdPermiso, c.SubCategoria).enRol)?.length }})</p>
                    <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :style="{ transform: expandedSubcategories[subgroup.IdPermiso] ? 'scaleY(1)' : 'scaleY(-1)' }">
                      <path d="M5.70711 9.71069C5.31658 10.1012 5.31658 10.7344 5.70711 11.1249L10.5993 16.0123C11.3805 16.7927 12.6463 16.7924 13.4271 16.0117L18.3174 11.1213C18.708 10.7308 18.708 10.0976 18.3174 9.70708C17.9269 9.31655 17.2937 9.31655 16.9032 9.70708L12.7176 13.8927C12.3271 14.2833 11.6939 14.2832 11.3034 13.8927L7.12132 9.71069C6.7308 9.32016 6.09763 9.32016 5.70711 9.71069Z" class="fill-principal" :class="{'fill-secundario': !isEditingPermisos || isSubcategoryChecked(subgroup).checkedEnRol}"/>
                    </svg>
                  </div>
                </div>

                <div v-if="subgroup.permiso != 'General' && expandedSubcategories[subgroup.IdPermiso]" class="ms-5">
                  <div class="m-0 fs-8 mb-1 d-flex gap-3" v-for="fullPermiso in subgroup.children" :key="fullPermiso.IdPermiso">
                    <div class="form-check d-flex gap-3 p-0">
                      <input
                          class="form-check-input sombra-sm m-0"
                          :class="{'form-check-input-gris': hasPermiso(fullPermiso.IdPermiso, fullPermiso.SubCategoria).enRol}"
                          type="checkbox"
                          :checked="hasPermiso(fullPermiso.IdPermiso, fullPermiso.SubCategoria).enPermiso || hasPermiso(fullPermiso.IdPermiso, fullPermiso.SubCategoria).enRol"
                          @change="togglePermiso(fullPermiso, $event.target.checked)"
                          :disabled="!isEditingPermisos || hasPermiso(fullPermiso.IdPermiso, fullPermiso.SubCategoria).enRol"
                      />
                      <p class="m-0 text-start" :class="{'texto-secundario': !isEditingPermisos || !hasPermiso(fullPermiso.IdPermiso, fullPermiso.SubCategoria).enPermiso}">
                          {{ fullPermiso.permiso }}
                      </p>

                      <div v-if="fullPermiso.Descripcion" class="tooltip-container">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" viewBox="0 0 24 24" fill="none" class="stroke-secundario" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <circle cx="12" cy="12" r="10"></circle>
                            <line x1="12" y1="16" x2="12" y2="12"></line>
                            <line x1="12" y1="8" x2="12" y2="8"></line>
                        </svg>
                        <span class="tooltip-text-left text-left" style="max-width: 50vw; width: 350px;">
                            <p class="m-0 fs-8">{{fullPermiso.Descripcion}}</p>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="subgroup.permiso == 'General'">
                  <div class="m-0 fs-8 mb-1 d-flex gap-3" v-for="fullPermiso in subgroup.children" :key="fullPermiso.IdPermiso">
                    <div class="form-check d-flex gap-3 p-0">
                      <input
                          class="form-check-input sombra-sm m-0"
                          :class="{'form-check-input-gris': hasPermiso(fullPermiso.IdPermiso, fullPermiso.SubCategoria).enRol}"
                          type="checkbox"
                          :checked="hasPermiso(fullPermiso.IdPermiso, fullPermiso.SubCategoria).enPermiso || hasPermiso(fullPermiso.IdPermiso, fullPermiso.SubCategoria).enRol"
                          @change="togglePermiso(fullPermiso, $event.target.checked)"
                          :disabled="!isEditingPermisos || hasPermiso(fullPermiso.IdPermiso, fullPermiso.SubCategoria).enRol"
                      />
                      <p class="m-0 text-start" :class="{'texto-secundario': !isEditingPermisos || !hasPermiso(fullPermiso.IdPermiso, fullPermiso.SubCategoria).enPermiso}">
                          {{ fullPermiso.permiso }}
                      </p>

                      <div v-if="fullPermiso.Descripcion" class="tooltip-container">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" viewBox="0 0 24 24" fill="none" class="stroke-secundario" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <circle cx="12" cy="12" r="10"></circle>
                            <line x1="12" y1="16" x2="12" y2="12"></line>
                            <line x1="12" y1="8" x2="12" y2="8"></line>
                        </svg>
                        <span class="tooltip-text-left text-left" style="max-width: 50vw; width: 350px;">
                            <p class="m-0 fs-8">{{fullPermiso.Descripcion}}</p>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex flex-column rounded-4 fondo-secundario p-2 px-3">
      <p class="m-0 text-start">{{ $t('ayuda') }}:</p>
      <div class="d-flex gap-2 align-items-center">
        <input
          class="form-check-input form-check-input-gris sombra-sm m-0"
          type="checkbox"
          checked
          disabled
        />
        <p class="m-0 text-start">{{ $t('permisosAsignadosEnUnRol') }}</p>
      </div>
      <div class="d-flex gap-2 align-items-center">
        <input
          class="form-check-input sombra-sm m-0"
          type="checkbox"
          checked
          disabled
        />
        <p class="m-0 text-start">{{ $t('permisosAsignables') }}</p>
      </div>
    </div>

    <div class="d-flex flex-row gap-2">
      <button class="btn success-btn d-flex align-items-center gap-2" type="submit" v-if="isEditingPermisos" :disabled="loadingPermisos">
        {{ $t('guardarCambios') }}
        <img v-if="loadingPermisos" src="@/assets/LOADING.gif" style="width: 20px;" alt="Cargando..." />
      </button>
      <button class="btn secondary-btn" @click="isEditingPermisos = false" v-if="isEditingPermisos">{{ $t('cancelar') }}</button>
    </div>
  </form>
</template>

<script>
import { ref, onMounted, computed, reactive, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import api from '@/services/api';

export default {
  name: 'PermisosSection',
  props: {
    persona: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props, { emit }) {
    const { t } = useI18n();
    const isEditingPermisos = ref(false);
    const loadingPermisos = ref(false);
    const allPermisos = ref([]);
    const expandedSubcategories = reactive({});
    const localPersona = ref(JSON.parse(JSON.stringify(props.persona || {})));

    const hasPermiso = (permisoId, subCategoria) => {
      // Check if the current persona has this specific permission
      // DEBUG: Log the permission check
      console.log(`[hasPermiso] Checking permisoId: ${permisoId}, subCategoria: ${subCategoria || 'undefined'}`);
      console.log(`[hasPermiso] localPersona.PersonasPermisos:`, localPersona.value.PersonasPermisos);
      
      const hasPermiso = localPersona.value.PersonasPermisos?.some(
        pp => pp.Permiso?.IdPermiso === permisoId
      );
      const hasPermisoInRole = localPersona.value.PersonasRoles?.some(
        persRoles => persRoles.Rol?.Permisos?.some(p => p.IdPermiso === permisoId)
      );
      console.log(`[hasPermiso] Result - enPermiso: ${hasPermiso}, enRol: ${hasPermisoInRole}`);
      return { enPermiso: hasPermiso, enRol: hasPermisoInRole };
    };

    const togglePermiso = (permiso, isChecked) => {
      // This method would handle updating the persona's permissions.
      console.log(
        `[togglePermiso] Permiso ID: ${permiso.IdPermiso}, Checked: ${isChecked}, SubCategoria: ${permiso.SubCategoria}`
      );
      
      if (isChecked) {
        if (!localPersona.value.PersonasPermisos) {
          localPersona.value.PersonasPermisos = [];
        }
        // DEBUG: Check if permission already exists to avoid duplicates
        const existingIndex = localPersona.value.PersonasPermisos.findIndex(
          pp => pp.IdPermiso === permiso.IdPermiso
        );
        if (existingIndex === -1) {
          console.log(`[togglePermiso] Adding NEW permission: ${permiso.IdPermiso}`);
          localPersona.value.PersonasPermisos.push({
            IdPersona: localPersona.value.IdPersona,
            IdPermiso: permiso.IdPermiso,
            IdPermisoNavigation: permiso
          });
        } else {
          console.log(`[togglePermiso] Permission ${permiso.IdPermiso} already exists, skipping duplicate`);
        }
      } else {
        console.log(`[togglePermiso] Removing permission: ${permiso.IdPermiso}`);
        localPersona.value.PersonasPermisos = localPersona.value.PersonasPermisos.filter(
          pp => pp.IdPermiso !== permiso.IdPermiso
        );
      }
      console.log(`[togglePermiso] Current PersonasPermisos count: ${localPersona.value.PersonasPermisos?.length}`);
    };

    const isSubcategoryChecked = (subgroup) => {
      // Una subcategoría está marcada si *todos* sus permisos hijos están marcados
      // (ya sea directamente o por rol)
      const checked = subgroup.children.every(p => {
        const status = hasPermiso(p.IdPermiso, p.SubCategoria);
        return status.enPermiso || status.enRol;
      });
      const checkedEnRol = subgroup.children.every(p => {
        const status = hasPermiso(p.IdPermiso, p.SubCategoria);
        return status.enRol;
      });
      return { checked: checked, checkedEnRol: checkedEnRol };
    };

    // Nueva: Maneja el cambio del checkbox de la subcategoría
    const toggleSubcategory = (subgroup, isChecked) => {
      if (!isEditingPermisos.value) return;

      console.log(`Toggle Subcategoría: ${subgroup.permiso}, Checked=${isChecked}`);

      // Iterar sobre todos los permisos hijos de esta subcategoría
      subgroup.children.forEach(permisoIndividual => {
        // La propiedad 'Subcategoria' de cada permisoIndividual aquí ya contiene el VALOR específico
        // (ej. 'Inicial', 'Boletines')
        togglePermiso(permisoIndividual, isChecked);
      });
    };

    const groupedPermisos = computed(() => {
      const categories = {}; // Objeto para agrupar por Categoria

      allPermisos.value.forEach(permiso => {
        const categoria = permiso.Categoria || 'Otros';
        const SubCategoria = permiso.SubCategoria || 'General'; // Usa 'General' si SubCategoria es null o vacía

        if (!categories[categoria]) {
          categories[categoria] = {}; // Crea un objeto para las subcategorías dentro de esta categoría
        }
        if (!categories[categoria][SubCategoria]) {
          categories[categoria][SubCategoria] = []; // Crea un array para los permisos dentro de esta subcategoría
        }
        categories[categoria][SubCategoria].push(permiso);
      });

      const result = [];
      const sortedCategoryNames = Object.keys(categories).sort((a, b) => {
        if (a === 'Otros') return 1;
        if (b === 'Otros') return -1;
        return a.localeCompare(b);
      });

      sortedCategoryNames.forEach(categoryName => {
        const subcategoriesData = [];
        const sortedSubcategoryNames = Object.keys(categories[categoryName]).sort((a, b) => {
          if (a === 'General') return -1; // 'General' (sin subcategoría) primero
          if (b === 'General') return 1;
          return a.localeCompare(b);
        });

        sortedSubcategoryNames.forEach(subcategoryName => {
          // Obtenemos los permisos de esta subcategoría
          const permisosInSubcategory = categories[categoryName][subcategoryName].sort((a, b) =>
            a.permiso.localeCompare(b.permiso)
          );

          // También necesitamos un "permiso proxy" para la subcategoría si queremos marcarlo
          // Esto es crucial para poder tener un checkbox a nivel de subcategoría
          // que represente el estado de todos sus permisos hijos.
          // Para simplificar ahora, el ID de este "permiso proxy" puede ser un ID sintético.
          const subcategoryProxyPermiso = {
            IdPermiso: `_SUB_${categoryName}_${subcategoryName}`, // ID sintético para el checkbox de subcategoría
            permiso: subcategoryName, // El nombre que se mostrará para la subcategoría
            Descripcion: `Gestiona todos los permisos de ${subcategoryName} dentro de ${categoryName}.`,
            Categoria: categoryName,
            SubCategoria: subcategoryName,
            isSubcategoryHeader: true, // Indicador para el template
            children: permisosInSubcategory, // Los permisos reales anidados
          };

          subcategoriesData.push(subcategoryProxyPermiso);
        });

        result.push({
          name: categoryName,
          subcategories: subcategoriesData // Ahora contiene las subcategorías con sus permisos hijos
        });
      });

      return result;
    });

    // Fetch permisos de la BD
    const fetchPermisos = async () => {
      try {
        const response = await api.get(`api/Permisos`);
        allPermisos.value = response.data;
        //console.log(allPermisos.value)
      } catch (error) {
        console.error('Error al obtener permisos:', error);
      }
    };

    const savePermisos = async () => {
      if (!localPersona.value || !localPersona.value.IdPersona) {
        console.error('No se ha cargado una persona para actualizar.');
        alert('Error: No hay datos de la persona.');
        return;
      }

      loadingPermisos.value = true;
      try {
        // 1. Extraer SOLAMENTE la lista de IDs de los permisos
        const permisoIds = localPersona.value.PersonasPermisos.map(permiso => permiso.IdPermiso);

        await api.put(`api/Persona/${localPersona.value.IdPersona}/Permisos`, permisoIds);

        isEditingPermisos.value = false;
        emit('updated');
      } catch (error) {
        console.error('Error al guardar los permisos:', error);
        alert('Hubo un problema al guardar los permisos.');
      } finally {
        loadingPermisos.value = false;
      }
    };

    watch(() => props.persona, (newPersona) => {
      localPersona.value = JSON.parse(JSON.stringify(newPersona || {}));
    }, { immediate: true });

    onMounted(async () => {
      await fetchPermisos();
    });

    return {
      t,
      isEditingPermisos,
      loadingPermisos,
      allPermisos,
      expandedSubcategories,
      hasPermiso,
      togglePermiso,
      groupedPermisos,
      isSubcategoryChecked,
      toggleSubcategory,
      savePermisos,
    };
  },
};
</script>

<style>
</style>